module.exports = __webpack_public_path__ + "media/whats_your_status_series_while_you_wait_to_hear/Colleges_sidebar02-86b446fc.gif";